import { render, staticRenderFns } from "./bm-dashboard-main.vue?vue&type=template&id=59595c29&"
import script from "./bm-dashboard-main.vue?vue&type=script&lang=js&"
export * from "./bm-dashboard-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports